import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Orders list configuration
 * Orders for today (embedded in client view)
 */
export const clientEmbeddedOrdersList: ListBuilderList = {
	id: 'client-embedded-orders',
	cacheTTL: 600000,
	name: "Today's Orders",
	type: 'default',
	active: true,
	sortOrder: 1,
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Orders created today',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		// No orderStatus rule: "Today's Orders" means every status, so we OMIT the
		// status filter rather than pre-selecting every option. Enumerating all
		// statuses (PD-14232) cluttered the filter bar with a chip per status and,
		// because the list was a fixed set of standard codes, actually EXCLUDED
		// tenant-specific custom string statuses. An absent filter returns all
		// statuses (the backend applies no status WHERE clause).
	},
};
